module.exports = __webpack_public_path__ + "static/ISO-0a0e3c6ceb14f2fdcd98ef1eb1ec0160.png";